import { Form } from '@/hooks/use-form-field';
import { convertEmptyStringsToNull } from '@/schemas/converters';
import { FormProps, FormValues } from '@/constants/formTypes';
import { DynamicRenderer } from './DynamicRenderer';
import useDynamicForm from '@/hooks/use-dynamic-form';

export function DynamicForm({ formData, onSubmit, route }: FormProps) {
  const form = useDynamicForm(formData.components);

  function handleFormSubmit(data: FormValues) {
    const convertedData = convertEmptyStringsToNull(data);

    void onSubmit(convertedData);
  }

  return (
    <Form {...form}>
      <form
        onSubmit={(ev) => void form.handleSubmit(handleFormSubmit)(ev)}
        id={formData.id ?? ''}
      >
        <DynamicRenderer
          form={form}
          components={formData.components}
          route={route}
          submit={handleFormSubmit}
        />
      </form>
    </Form>
  );
}
